var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.objectURL)?_c('v-img',{staticClass:"no-flow",attrs:{"contain":"","src":_vm.objectURL,"alt":_vm.altText,"max-width":"340"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }